'use client'

import {BrandsPageContent} from '../types'
import first from 'lodash/first'
import React from 'react'

import {Routes} from '@/src/config/routes'

import {Brand} from '@/src/entities/brand'

import noPhotoPic from '@/src/shared/assets/media/no-photo.png'
import {Link} from '@/src/shared/ui/link'
import {headerHeight} from '@/src/shared/utils/functions'

import * as UI from './screen.styled'
import {PageData} from '@/src/core/domain/entities/page/page-data'

const mapFirstLetters = (brands: Brand[]) => {
  const map = new Map()

  for (const brand of brands) {
    let firstLetter = first(brand.name)

    if (!firstLetter) throw new Error(`Unexpected name, ${JSON.stringify(brand)}`)

    if (firstLetter.search(/\d/) >= 0) {
      firstLetter = '0-9'
    }

    let mapBrandList = map.get(firstLetter)

    if (!mapBrandList) {
      mapBrandList = []
      map.set(firstLetter, mapBrandList)
    }

    mapBrandList.push(brand)
  }

  return map
}

const BrandsScreen: React.FC<PageData<BrandsPageContent>> = ({content: {brands}}) => {
  const brandsList = brands ?? []

  const map = mapFirstLetters(brandsList)

  const letters = Array.from(map.entries())
    .sort()
    .map(([k]) => k)

  return (
    <UI.Wrapper>
      <UI.ImageList>
        {brandsList.length > 0 ? (
          brandsList.map(brand => (
            <Link href={Routes.brands.detail(brand.name)} title={brand.name} key={brand.id}>
              <UI.BrandImage
                src={(brand.image && brand.image.type == 'image' && brand.image.src) || noPhotoPic}
                sizes="100vh"
                width={0}
                height={0}
                alt=""
              />
            </Link>
          ))
        ) : (
          <h3>Список пуст</h3>
        )}
      </UI.ImageList>

      <LettersSection letters={letters} map={map} />
    </UI.Wrapper>
  )
}

interface IPropsLetters {
  letters: string[]
  map: Map<string, Brand[]>
}

const stripLetter = (letter: string) => `i${letter.replace('-', '')}`

const LettersSection = ({letters, map}: IPropsLetters) => {
  const goLetterSection = (letter: string) => {
    const el = document.querySelector<any>(`#${stripLetter(letter)}`)
    try {
      window.scroll({
        top: el.offsetTop - headerHeight(),
        behavior: 'smooth',
      })
    } catch (e) {
      console.error(e)
      el!.scrollIntoView()
    }
  }

  return (
    <UI.LettersWrapper>
      <UI.LettersLinks>
        {letters.map(letter => (
          <UI.Letter onClick={() => goLetterSection(letter)} key={`LettersLinks-${letter}`}>
            {letter}
          </UI.Letter>
        ))}
      </UI.LettersLinks>

      <UI.Container>
        {letters.map((letter, i) => (
          <React.Fragment key={i}>
            <UI.Letter as={Link} noLink id={stripLetter(letter)} key={`Letter-${letter}`}>
              {letter}
            </UI.Letter>
            <UI.Brands>
              {map.get(letter)!.map(brand => (
                <Link key={`Brand-${letter}-${brand.name}`} href={Routes.brands.detail(brand.name)}>
                  {brand.name}
                </Link>
              ))}
            </UI.Brands>
          </React.Fragment>
        ))}
      </UI.Container>
    </UI.LettersWrapper>
  )
}

export default BrandsScreen
